module.exports = __webpack_public_path__ + "img/tekken_01.8f53399e.jpg";